import type { Notification, NotificationType } from "@/types/ui";
import { defineStore } from "pinia";
import { v4 as uuidv4 } from 'uuid';

export interface NotificationStoreState {
    notifications: Notification[];
}

export const useNotificationStore = defineStore('notification', {
    state: (): NotificationStoreState => ({
        notifications: [],
    }),
    actions: {
        add({ text, type }: { text: string, type: NotificationType }) {
            let duration = 10000;
            switch (type) {
                case 'success':
                    duration = 5000;
                    break;

                case 'error':
                    duration = 15000;
                    break;
                default:
                    break;
            }

            const notification = {
                id: uuidv4(),
                type,
                text,
                duration,
            };

            this.notifications.push(notification);

            setTimeout(() => {
                this.remove(notification);
            }, duration);
        },

        addSuccess(text: string) {
            this.add({ type: 'success', text});
        },

        addWarning(text: string) {
            this.add({ type: 'warning', text});
        },

        addError(text: string) {
            this.add({ type: 'error', text});
        },

        remove(notification: Notification) {
            this.notifications = this.notifications.filter(({ id }) => id !== notification.id);
        }
    }
});
